import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

// Material components
import Dialog from '@material-ui/core/Dialog'
import { Button, Typography, IconButton, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'


const styles = theme => ({
	root: {
		margin: 0,
		padding: theme.spacing(1),
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(0),
		top: theme.spacing(0),
		// color: theme.palette.grey[500],
	},
})

const DialogTitleStyled = withStyles(styles)(props => {
	const { children, classes, onClose } = props
	return (
		<DialogTitle disableTypography className={classes.root}>
			<Typography variant="h5">{children}</Typography>
			{onClose ? (
				<IconButton
					aria-label="close"
					className={classes.closeButton}
					onClick={onClose}
				>
					<CloseIcon />
				</IconButton>
			) : null}
		</DialogTitle>
	)
})

const DialogContentStyled = withStyles(theme => ({
	root: {
		padding: theme.spacing(2),
	},
}))(DialogContent)

export default function GenericDialog(props) {
	return (
		<div>
			<Dialog
				fullWidth={true}
				maxWidth={props.size}
				onClose={props.onClose}
				aria-labelledby="customized-dialog-title"
				open={props.isOpen}
				disableEscapeKeyDown={true}
				disableBackdropClick={true}
			>
				<DialogTitleStyled
					id="customized-dialog-title"
					onClose={props.onClose}
				>
					{props.title}
				</DialogTitleStyled>

				<DialogContentStyled dividers>
					{props.children}
				</DialogContentStyled>
				<DialogActions>
					{
						props.actions.map((action, i) =>
							<Button onClick={action.func} color="primary" key={i}>
								{ action.title }
							</Button>
						)
					}
                </DialogActions>
			</Dialog>
		</div>
	)
}

GenericDialog.propTypes = {
	title: PropTypes.string.isRequired,
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	size: PropTypes.string,
	actions: PropTypes.array,
}

GenericDialog.defaultProps = {
	size: 'lg',
	actions: [],

}

